__turbopack_context__.v({
  "loginLink": "DSiHbG_loginLink",
  "navigationContainer": "DSiHbG_navigationContainer",
});
